import React from 'react';
import { WhitePanelLayout } from '@dom/components';
import differenceInDays from 'date-fns/difference_in_days';
// import { Button } from 'reactstrap';

// const JoinNowButton = () => <Button color="yellow" size="sm">Join Now</Button>

export default function upcomingTreks({ upcomingTreks }) {
  if (!upcomingTreks) return null;
  return (
    <WhitePanelLayout title="Upcoming / Previous Treks">
      <div className="upcoming-table">
        <div className="trek-row trek-row-head">
          <div className="name">Trek Name</div>
          <div className="date">Start Date</div>
          <div className="days">Days</div>
        </div>
      {
        upcomingTreks && upcomingTreks.map(trek => {
          return (
            <div
            key={trek.startDate}
            className="trek-row"
            >
              <div className="name">{trek.title}</div>
              <div className="date">{trek.startDate}</div>
              <div className="days">{differenceInDays(trek.endDate, trek.startDate)} Days</div>
            </div>
          )
        })
      }
      </div>
    </WhitePanelLayout>
  );
}
